enum FeatureFlag {
  FIELDS_INSTRUCTION_HTML = "fields-instruction-html",
  MULTIPLE_PHOTOS = "multiple-photos",
}

export default FeatureFlag;
